import React from "react";

function normalize(item){

if(!item){

return{

text:"Metric",
priority:"MEDIUM",
effort:"MEDIUM",
impact:"MEDIUM"

};

}

if(typeof item==="string"){

return{

text:item,
priority:"MEDIUM",
effort:"MEDIUM",
impact:"MEDIUM"

};

}

return{

text:item.text || "Metric",
priority:item.priority || "MEDIUM",
effort:item.effort || "MEDIUM",
impact:item.impact || "MEDIUM"

};

}

function priorityColor(priority){

if(priority==="HIGH")
return "bg-red-100 text-red-700";

if(priority==="MEDIUM")
return "bg-amber-100 text-amber-700";

return "bg-green-100 text-green-700";

}

export default function MetricsPanel({data}){

const metrics=(data?.metrics || [])
.filter(Boolean)
.map(normalize);

return(

<div className="bg-white border rounded-xl p-6 shadow-sm">

<h3 className="text-lg font-semibold text-blue-900">
Key Metrics
</h3>

<div className="space-y-3 mt-4">

{metrics.length===0 &&(

<p className="text-sm text-slate-500">
No metrics generated.
</p>

)}

{metrics.map((item,i)=>(

<div
key={i}
className="bg-green-50 border border-green-200 rounded-lg p-3 text-sm"
>

<p className="text-slate-700">

{item.text}

</p>

<div className="flex gap-2 mt-2 flex-wrap">

<span className={`text-xs px-2 py-1 rounded ${priorityColor(item.priority)}`}>
{item.priority}
</span>

<span className="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded">
Effort {item.effort}
</span>

<span className="text-xs bg-green-100 text-green-700 px-2 py-1 rounded">
Impact {item.impact}
</span>

</div>

</div>

))}

</div>

</div>

);

}